import BootstrapVue from 'bootstrap-vue';
import Vuelidate from 'vuelidate';
import 'echarts';
import ECharts from 'vue-echarts/components/ECharts';
import VueTheMask from 'vue-the-mask';
import Toasted from 'vue-toasted';
import I18n from '@/i18n/i18n';
import VueAutonumeric from 'vue-autonumeric';
import calendar from './calendar';

export default (Vue) => {
  Vue.use(BootstrapVue);
  Vue.use(Vuelidate);
  Vue.use(VueTheMask);
  Vue.component('e-chart', ECharts);
  Vue.use(Toasted, {
    iconPack: 'fontawesome',
    className: 'font-weight-bold',
  });
  Vue.component('vue-autonumeric', VueAutonumeric);

  I18n.init(Vue);
  Vue.use(calendar);
  return {
    i18n: I18n.i18n,
  };
};
